/**
 * /signup's guard. A portal's calculator hands a calculation over through
 * `/signup?handoff=…` (D7). The token is kept for this tab BEFORE the public-
 * only guard runs: a person already signed in is sent on at once — sign-up is
 * for people without an account — and goes on to InOut, which adopts the
 * calculation, instead of to the dashboard with it lost. Signed out, sign-up
 * reads the kept token and says the calculation back.
 */
import { useState, type ReactNode } from 'react';

import { PublicOnlyRoute } from '@/components/guards/ProtectedRoute';
import { takeHandoffFromAddress } from '@/features/heroes/inout/lib/pending-handoff';

import { citizenHome } from '../account-portal';

export function SignupRoute({ children }: { children: ReactNode }) {
  // Once, on the first render — before the guard decides where a session goes.
  useState(takeHandoffFromAddress);
  return <PublicOnlyRoute redirectTo={citizenHome()}>{children}</PublicOnlyRoute>;
}
